"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Monster = void 0;
const magic_1 = require("./magic");
const static_1 = require("./static");
const util_1 = require("./util");
class Monster {
    constructor() {
        this.weak = null;
        this.parts = [];
        this.skills = [];
        this.paletteInsertType = '';
        this.outputOption = {
            addCommandsPartition: true,
            addCommandsShortcut: true,
            noStatus: false,
        };
    }
    getName() {
        return this.name;
    }
    static generateInstanceFromYutorize(resYutorize, outputOption) {
        var _a;
        const monster = new Monster();
        if (!resYutorize) {
            return monster;
        }
        if (!!outputOption) {
            monster.outputOption = outputOption;
        }
        resYutorize = Object.fromEntries(Object.entries(resYutorize).map((entry) => [entry[0], (0, util_1.unescapeHtml)(entry[1])]));
        monster.name = resYutorize['monsterName'];
        monster.taxa = resYutorize['taxa'];
        monster.url = `https://yutorize.2-d.jp/ytsheet/sw2.5/?id=${resYutorize['id']}`;
        monster.vitResist = (0, util_1.string2Int)(resYutorize['vitResist']);
        monster.mndResist = (0, util_1.string2Int)(resYutorize['mndResist']);
        monster.reputation = (0, util_1.string2Int)(resYutorize['reputation']);
        monster.weak = (0, util_1.string2Int)(resYutorize['reputation+']);
        monster.paletteInsertType = resYutorize['paletteInsertType'];
        const chatPalette = (_a = resYutorize['chatPalette']) !== null && _a !== void 0 ? _a : '';
        monster.chatPalette = chatPalette.split('<br>');
        const partsNum = resYutorize['partsNum'] !== undefined ? (0, util_1.string2Int)(resYutorize['partsNum']) : 1;
        for (let i = 1; i <= partsNum; i++) {
            const part = new MonsterPart();
            const inCloser = /[\(（](.*?)[\)）]/g;
            if (!resYutorize[`status${i}Style`])
                continue;
            if (!!resYutorize[`status${i}Style`].match(inCloser)) {
                part.name = resYutorize[`status${i}Style`].match(inCloser)[0].slice(1, -1);
                part.atkway = resYutorize[`status${i}Style`].slice(0, resYutorize[`status${i}Style`].search(inCloser));
            }
            else {
                part.name = resYutorize[`status${i}Style`];
                part.atkway = resYutorize[`status${i}Style`];
            }
            part.acc = resYutorize[`status${i}Accuracy`] !== '' ? (0, util_1.string2Int)(resYutorize[`status${i}Accuracy`]) : null;
            part.avo = resYutorize[`status${i}Evasion`] !== '' ? (0, util_1.string2Int)(resYutorize[`status${i}Evasion`]) : null;
            part.dmg = resYutorize[`status${i}Damage`] !== '' ? resYutorize[`status${i}Damage`] : null;
            part.def = (0, util_1.string2Int)(resYutorize[`status${i}Defense`]);
            part.hp = (0, util_1.string2Int)(resYutorize[`status${i}Hp`]);
            part.mp = (0, util_1.string2Int)(resYutorize[`status${i}Mp`]);
            monster.parts.push(part);
        }
        // 部位名の重複を解消
        const duplicateNameList = monster.parts.filter((part, i, self) => self.findIndex((elem) => elem.name === part.name) !== i).map(e => e.name);
        duplicateNameList.forEach(dupName => {
            const dupCodeList = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
            monster.parts.filter(part => part.name === dupName).forEach((part, i) => {
                part.name = part.name + dupCodeList[i];
            });
        });
        monster.skills = Monster.convertSkills(resYutorize['skills']);
        return monster;
    }
    generateCCFOLIA() {
        let status = [];
        if (this.parts.length === 1) {
            status.push({
                label: `HP`,
                value: this.parts[0].hp,
                max: this.parts[0].hp,
            });
            status.push({
                label: `MP`,
                value: this.parts[0].mp,
                max: this.parts[0].mp,
            });
            status.push({
                label: `DEF`,
                value: this.parts[0].def,
                max: this.parts[0].def,
            });
        }
        else if (this.parts.length >= 3) {
            this.parts.forEach(part => {
                status.push(part.generateStatusHP());
            });
            this.parts.forEach(part => {
                if (part.mp > 0)
                    status.push(part.generateStatusMP());
            });
            this.parts.forEach(part => {
                status.push(part.generateStatusDef());
            });
        }
        else {
            this.parts.forEach(part => {
                status.push(part.generateStatusHP());
                if (part.mp > 0)
                    status.push(part.generateStatusMP());
                status.push(part.generateStatusDef());
            });
        }
        const memoList = [];
        memoList.push(`知名度：${this.reputation}`);
        if (!!this.weak)
            memoList.push(`弱点値：${this.weak}`);
        let commands = '';
        if (this.paletteInsertType === 'exchange') {
            if (this.chatPalette.join('') === '')
                commands += this.generateCommands();
            commands += this.chatPalette.join('\n');
        }
        else if (this.paletteInsertType === 'begin') {
            commands += this.chatPalette.join('\n');
            commands += '\n\n';
            commands += this.generateCommands();
        }
        else if (this.paletteInsertType === 'end') {
            commands += this.generateCommands();
            commands += '\n\n';
            commands += this.chatPalette.join('\n');
        }
        // console.info(this.generateCommands());
        let params = [];
        this.skills.forEach(skill => {
            if (skill.power)
                params.push(skill.generateParam());
        });
        const clipboardData = { kind: 'character', data: {} };
        clipboardData.data = {
            name: this.name,
            memo: memoList.join('\n'),
            initiative: 0,
            externalUrl: this.url,
            status: status,
            params: params,
            iconUrl: null,
            faces: [],
            x: 0,
            y: 0,
            angle: 0,
            width: 4,
            height: 4,
            active: false,
            secret: true,
            invisible: false,
            hideStatus: false,
            commands: commands,
            owner: null
        };
        return JSON.stringify(clipboardData);
    }
    generateCommands() {
        let commands = [];
        // 巻き込まれ
        commands.push('1d>=4 【巻き込まれ】');
        // 抵抗
        if (this.outputOption.addCommandsShortcut) {
            commands.push(`2d+${this.vitResist} 【生命抵抗判定】@${static_1.CommandShortcut.DEFENCE}`);
            commands.push(`2d+${this.mndResist} 【精神抵抗判定】@${static_1.CommandShortcut.DEFENCE}`);
        }
        else {
            commands.push(`2d+${this.vitResist} 【生命抵抗判定】`);
            commands.push(`2d+${this.mndResist} 【精神抵抗判定】`);
        }
        // 部位ごとのやつ
        this.parts.forEach(part => {
            commands.push(part.generateCommands());
        });
        // 特殊能力系
        this.skills.forEach(skill => {
            commands.push(skill.generateCommands());
        });
        return commands.join('\n');
    }
    static convertSkills(skilldata) {
        const skills = [];
        if (!skilldata)
            return skills;
        const skillRows = skilldata.split('<br>');
        let beforeSkill;
        // console.info(skillRows);
        skillRows.forEach(row => {
            // 一部の記号と英数字を半角にする
            row = (0, util_1.zen2han)(row);
            if (row.trim().match(/^△?(>|▶|〆|>>|☆|≫|○|◯|〇).+/)) {
                const rowSplited = row.trim().split('/');
                const skill = new Skill();
                // console.info(rowSplited[0].lastIndexOf('>'));
                skill.name = rowSplited[0].slice(rowSplited[0].search(/(>|▶|〆|>>|☆|≫|○|◯|〇)/) + 1);
                // 魔法だったとき
                if (/(.{2}魔法|魔動機術|召異魔術)/.test(skill.name)) {
                    const magicName = skill.name.slice(skill.name.search(/(.{2}魔法)|魔動機術/)).slice(0, 4);
                    let magicJob;
                    const level = (0, util_1.string2Int)(skill.name.replace(/[^0-9]/g, ''));
                    if (magicName === `真語魔法`) {
                        magicJob = magic_1.MagicJob.generateMagicJob(static_1.JobLabel.sorcerer, level);
                    }
                    else if (magicName === `操霊魔法`) {
                        magicJob = magic_1.MagicJob.generateMagicJob(static_1.JobLabel.conjurer, level);
                    }
                    else if (magicName === `深智魔法`) {
                        magicJob = magic_1.MagicJob.generateMagicJob(static_1.JobLabel.wizard, level);
                    }
                    else if (magicName === `神聖魔法`) {
                        magicJob = magic_1.MagicJob.generateMagicJob(static_1.JobLabel.priest, level);
                    }
                    else if (magicName === `妖精魔法`) {
                        magicJob = magic_1.MagicJob.generateMagicJob(static_1.JobLabel.fairytamer, level);
                    }
                    else if (magicName === `魔動機術`) {
                        magicJob = magic_1.MagicJob.generateMagicJob(static_1.JobLabel.magitech, level);
                    }
                    else if (magicName === `森羅魔法`) {
                        magicJob = magic_1.MagicJob.generateMagicJob(static_1.JobLabel.druid, level);
                    }
                    else if (magicName === `召異魔法`) {
                        magicJob = magic_1.MagicJob.generateMagicJob(static_1.JobLabel.demonruler, level);
                    }
                    else {
                        magicJob = magic_1.MagicJob.generateMagicJob('', level);
                    }
                    skill.name = magicName;
                    skill.magicjob = magicJob;
                }
                skill.isPassive = /^(○|◯|〇).+/.test(rowSplited[0]);
                skill.isQuick = /^△?(>>|☆|≫).+/.test(rowSplited[0]);
                skill.isBefore = /.*△.+/.test(rowSplited[0]);
                // 達成値取得
                // TODO ここに必中とかが入る場合もある
                if (rowSplited.length > 1) {
                    if (/^.*\d+\(\d+\)/.test(rowSplited[1])) {
                        skill.power = (0, util_1.string2Int)(rowSplited[1].slice(rowSplited[1].search(/\d/), rowSplited[1].indexOf('('))); // 数字の部分のみ抽出
                    }
                    else if (/必中/.test(rowSplited[1])) {
                        // 「抵抗:必中」は2番目に来るのでここで検証
                        skill.resistType = static_1.ResistType.NO_RESIST;
                    }
                }
                if (rowSplited.length > 3) {
                    // 抵抗がある場合
                    if (/精神/.test(rowSplited[2])) {
                        skill.resist = '精神抵抗力';
                    }
                    else if (/生命/.test(rowSplited[2])) {
                        skill.resist = '生命抵抗力';
                    }
                    else if (/回避/.test(rowSplited[2])) {
                        skill.resist = '回避力';
                    }
                    // 抵抗種別を検証
                    if (/半減/.test(rowSplited[3])) {
                        skill.resistType = static_1.ResistType.HALF;
                    }
                    else if (/消滅/.test(rowSplited[3])) {
                        skill.resistType = static_1.ResistType.NO_EFFECT;
                    }
                    else if (/短縮/.test(rowSplited[3])) {
                        skill.resistType = static_1.ResistType.REDUCTION;
                    }
                }
                beforeSkill = skill;
                skills.push(skill);
            }
            else {
                // 1行ずつ見るうちにダメージっぽいのがあったら前に設定したスキルに入れておく
                const damageArray = row.trim().match(/\dd((\+|\-)\d{1,2})?/i); // 「nd+m」(2d+12)等を検出
                if (!!damageArray)
                    beforeSkill.damage = damageArray[0].toLowerCase();
            }
        });
        return skills;
    }
}
exports.Monster = Monster;
class MonsterPart {
    constructor() {
        this._atkway = null;
        this._acc = null;
        this._avo = null;
        this._dmg = null;
        this._addCommandsShortcut = true;
    }
    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }
    get atkway() {
        return this._atkway;
    }
    set atkway(value) {
        this._atkway = value;
    }
    get acc() {
        return this._acc;
    }
    set acc(value) {
        this._acc = value;
    }
    get avo() {
        return this._avo;
    }
    set avo(value) {
        this._avo = value;
    }
    get def() {
        return this._def;
    }
    set def(value) {
        this._def = value;
    }
    get dmg() {
        return this._dmg;
    }
    set dmg(value) {
        this._dmg = value;
    }
    get hp() {
        return this._hp;
    }
    set hp(value) {
        this._hp = value;
    }
    get mp() {
        return this._mp;
    }
    set mp(value) {
        this._mp = value;
    }
    get addCommandsShortcut() {
        return this._addCommandsShortcut;
    }
    set addCommandsShortcut(value) {
        this._addCommandsShortcut = value;
    }
    generateStatusHP() {
        return {
            label: `${this.name}HP`,
            value: this.hp,
            max: this.hp,
        };
    }
    generateStatusMP() {
        return {
            label: `${this.name}MP`,
            value: this.mp,
            max: this.mp,
        };
    }
    generateStatusDef() {
        return {
            label: `${this.name}DEF`,
            value: this.def,
            max: this.def,
        };
    }
    generateCommands() {
        let commands = [];
        // 回避
        if (this.addCommandsShortcut) {
            if (this.avo && this.name === this.atkway)
                commands.push(`${generateCommand2d(this.avo)} 回避 @${static_1.CommandShortcut.DEFENCE}`);
            else if (this.avo)
                commands.push(`${generateCommand2d(this.avo)} 回避/${this.name} @${static_1.CommandShortcut.DEFENCE}`);
        }
        else {
            if (this.avo && this.name === this.atkway)
                commands.push(`${generateCommand2d(this.avo)} 回避`);
            else if (this.avo)
                commands.push(`${generateCommand2d(this.avo)} 回避/${this.name}`);
        }
        // 命中
        if (this.addCommandsShortcut) {
            if (this.acc)
                commands.push(`${generateCommand2d(this.acc)} 命中/${this.atkway}(${this.name}) @${static_1.CommandShortcut.ATTACK}`);
        }
        else {
            if (this.acc)
                commands.push(`${generateCommand2d(this.acc)} 命中/${this.atkway}(${this.name})`);
        }
        // ダメージ
        if (this.addCommandsShortcut) {
            if (this.dmg)
                commands.push(`${this.dmg} ダメージ/${this.atkway}(${this.name}) @${static_1.CommandShortcut.ATTACK}`);
        }
        else {
            if (this.dmg)
                commands.push(`${this.dmg} ダメージ/${this.atkway}(${this.name})`);
        }
        return commands.join(`\n`);
    }
}
class Skill {
    constructor() {
        this._isPassive = false;
        this._isQuick = false;
        this._isBefore = false;
        this._addCommandsShortcut = true;
    }
    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }
    get resist() {
        return this._resist;
    }
    set resist(value) {
        this._resist = value;
    }
    get resistType() {
        return this._resistType;
    }
    set resistType(value) {
        this._resistType = value;
    }
    get power() {
        return this._power;
    }
    set power(value) {
        this._power = value;
    }
    get damage() {
        return this._damage;
    }
    set damage(value) {
        this._damage = value;
    }
    get isPassive() {
        return this._isPassive;
    }
    set isPassive(value) {
        this._isPassive = value;
    }
    get isQuick() {
        return this._isQuick;
    }
    set isQuick(value) {
        this._isQuick = value;
    }
    get isBefore() {
        return this._isBefore;
    }
    set isBefore(value) {
        this._isBefore = value;
    }
    get magicjob() {
        return this._magicjob;
    }
    set magicjob(value) {
        this._magicjob = value;
    }
    get addCommandsShortcut() {
        return this._addCommandsShortcut;
    }
    set addCommandsShortcut(value) {
        this._addCommandsShortcut = value;
    }
    generateCommands() {
        let commands = [];
        // 使用宣言
        // commands.push(this.generatePlayCommand());
        // 行使判定
        if (this.power !== undefined) {
            if (this.magicjob) {
                if (this.addCommandsShortcut) {
                    commands.push(`2d+{${this.name}} >${this.name}行使 @${static_1.CommandShortcut.MAGIC}`);
                }
                else {
                    commands.push(`2d+{${this.name}} >${this.name}行使`);
                }
                this.magicjob.getMagicRates().forEach(magicRates => {
                    if (magicRates.type !== 'heal') {
                        magicRates.rates.forEach(rate => {
                            if (this.addCommandsShortcut) {
                                commands.push(`k${rate}[10]+{${this.name}} 威力${rate} @${static_1.CommandShortcut.DAMAGE}${rate}`);
                                commands.push(`hk${rate}[13]+{${this.name}} 威力${rate}半減 @${static_1.CommandShortcut.DAMAGE_HALF_S}${rate}`);
                            }
                            else {
                                commands.push(`k${rate}[10]+{${this.name}} 威力${rate}`);
                                commands.push(`hk${rate}[13]+{${this.name}} 威力${rate}半減`);
                            }
                        });
                    }
                    else {
                        magicRates.rates.forEach(rate => {
                            if (this.addCommandsShortcut) {
                                commands.push(`k${rate}[13]+{${this.name}} 威力${rate}回復 @${static_1.CommandShortcut.HEAL}${rate}`);
                            }
                            else {
                                commands.push(`k${rate}[13]+{${this.name}} 威力${rate}回復`);
                            }
                        });
                    }
                });
                commands = commands.concat(this.magicjob.magics.map(magic => magic.convertCommand())); // 魔法一覧
            }
            else {
                // 魔法じゃない特殊能力
                commands.push(`2d+{${this.name}} ${this.generatePlayCommand()}`);
                if (!!this.damage) {
                    if (this.addCommandsShortcut)
                        commands.push(`${this.damage} ${this.name}/ダメージ @${static_1.CommandShortcut.DAMAGE}`);
                    else
                        commands.push(`${this.damage} ${this.name}/ダメージ`);
                }
            }
        }
        return commands.join(`\n`);
    }
    // power(行使基準値)が設定されていないとエラー
    generateParam() {
        if (this.power) {
            return {
                label: this.name,
                value: this.power.toString(),
            };
        }
        else {
            throw new Error('No Definition "power".');
        }
    }
    generatePlayCommand() {
        const playCommand = [];
        if (this.isBefore)
            playCommand.push(`△`);
        if (this.isPassive)
            playCommand.push(`◯`);
        else if (this.isQuick)
            playCommand.push(`>>`);
        else
            playCommand.push(`>`);
        playCommand.push(this.name);
        if (this.resistType === static_1.ResistType.NO_RESIST) {
            playCommand.push(`/必中`);
            return playCommand.join('');
        }
        if (!!this.resist)
            playCommand.push(`/${this.resist}`);
        if (!!this.resistType)
            playCommand.push(`/${this.resistType}`);
        if (this.addCommandsShortcut)
            playCommand.push(` @${static_1.CommandShortcut.SKILL}`);
        return playCommand.join('');
    }
}
function generateCommand2d(num) {
    const command = [];
    command.push(`2d`);
    if (num < 0)
        command.push(`-`);
    else
        command.push(`+`);
    command.push(Math.abs(num).toString());
    return command.join('');
}
//# sourceMappingURL=monster.js.map